// Helper function to handle image URLs consistently across the app
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  
  // If URL is already absolute (starts with http/https), use as-is
  if (imageUrl.startsWith('http')) {
    return imageUrl;
  }
  
  // If URL is relative, prepend backend URL
  return `https://api.hajmetwalli.com/${imageUrl}`;
};
